import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getUsuariosCentro`, method: 'GET', body: null, token: token})
}